// extracted by mini-css-extract-plugin
export default {"button":"Button_button__xoOZq","primary":"Button_primary__NGIIN","outline":"Button_outline__uKaRu","ghost":"Button_ghost__tLrp+","icon":"Button_icon__s8cO1","sm":"Button_sm__5SAh2"};